import React from 'react'
import "../assets/css/employee-header.css";
import AuthContext from '../context/AuthContext';
import { useContext } from 'react';

function EmployeeHeader() {
    let {user, logoutUser} = useContext(AuthContext)
  return (
    <div>
        <nav className="navbar navbar-expand-lg bg-dark mb-5" data-bs-theme="dark">
        <div className="container-fluid">
            <a className="navbar-brand" href="#">Hello {user.username}</a>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            </ul>
            <form className="d-flex" role="search">
                <button className="btn btn-outline-danger" onClick={logoutUser}>Logout</button>
            </form>
            </div>
        </div>
        </nav>
    </div>
  )
}

export default EmployeeHeader